import {helpers} from "vuelidate/lib/validators";

function isValidFileType(value, options) {
    return options.fileTypes.indexOf(value.type) >= 0;
}

export const validFileType = (options) => helpers.withParams(
    { type: 'validFileType', value: options},
    (value) => {
        if(value == null){
            return true; // no form data, accept
        }
        for (const file of value){
            if(!file || !isValidFileType(file, options)){
                return false;
            }
        }
        return true;
    }
);

function isValidFileSize(value, options) {
    return value.size <= options.max;
}

export const validFileSize = (options) => helpers.withParams(
    { type: 'validFileSize', value: options},
    (value) => {
        if(value == null){
            return true; // no form data, accept
        }
        for (const file of value){
            if(!file || !isValidFileSize(file, options)){
                return false;
            }
        }
        return true;
    }
);